import { Theme } from '@shipengine/giger-theme';
import { css, SerializedStyles } from '@emotion/react';

export const getAdviceStyles = (theme: Theme): SerializedStyles =>
    css({
        border: `1px solid ${theme.palette.gray.light}`,
        borderBottom: `2px solid ${theme.palette.primary.dark}`,
    });
